/**
 * @description coupon state getters
 */

export default {
  couponList (state) {
    return state.couponList
  },
  selectedCoupon (state) {
    return state.couponInfo
  },
  productAvaliableCouponList (state) {
    return state.productAvaliableCouponList
  }
}
